import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FieldModule } from '@appkit4/angular-components/field';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { TextfieldComponent } from './components/textfield/textfield.component';

@NgModule({
  declarations: [TextfieldComponent],
  exports: [TextfieldComponent],
  imports: [FormsModule, FieldModule, TranslateDirective, TranslatePipe],
})
export class UiCommonModule {}
